// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ff4d0f8d","455":"4a69aabc","977":"8ffaff03"}[chunkId] + ".chunk.js";
};